import { render } from "./toggle-switch.html?vue&type=template&id=a34bc32e&scoped=true&ts=true&external"
import script from "./toggle-switch.ts?vue&type=script&lang=ts&external"
export * from "./toggle-switch.ts?vue&type=script&lang=ts&external"

import "./toggle-switch.scss?vue&type=style&index=0&id=a34bc32e&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a34bc32e"]])

export default __exports__